import React, { Dispatch, ReactNode, useState } from 'react'
import StyledDiv from './styles'
import { AddPaymentMethodForm, Button, Modal } from '../../../components'
import { LiteralsService } from '../../../services'
import { images } from '../../../images'
import { Stripe, StripeElements } from '@stripe/stripe-js'
import { useSelector } from 'react-redux'
import { IStoreState } from '../../../store/states'
import { Application } from '../../../config'

interface IProps {
  stripe: Stripe
  elements: StripeElements
  visible: boolean
  showAddOption: boolean
  addOptionText?: string
  privacyPolicyUrl: string
  amount: number
  pickedService?: number | null
  dispatch: Dispatch<any>
  updateUserInfo: () => void
  close: () => void
}

const { isIframe } = Application

export const AddPaymentModal: React.FC<IProps> = ({
  stripe,
  elements,
  visible,
  showAddOption,
  addOptionText,
  amount,
  pickedService,
  dispatch,
  updateUserInfo,
  close,
  privacyPolicyUrl
}) => {
  const [showPaymentStep, setShowPaymentStep] = useState(showAddOption ? false : true)
  const userInfo = useSelector((state: IStoreState) => state.userInfo)

  const getModalTitle = () => {
    if (isIframe) return 'userInfo'
    return userInfo && userInfo.paymentMethodId ? 'changePaymentMethod' : 'addPaymentMethod'
  }

  const modalContent = (): ReactNode => {
    return (
      <StyledDiv>
        {
          showPaymentStep || isIframe ?
          <div>
            <header>
              {
                !isIframe &&
                <img src={ images['goBack'] } alt='back' onClick={ () => setShowPaymentStep(false) } className={ showAddOption ? '' : 'hidden' } />
              }
              <h3>
                { LiteralsService.get(getModalTitle(), true) }
              </h3>
              <img src={ images['cross'] } alt='cross' onClick={ () => {
                setShowPaymentStep(showAddOption ? false : true)
                close()
              }} />
            </header>
            <section>
              { (userInfo && userInfo.stripeIds && userInfo.paymentMethodLastFour)  && 
                <div className="cards-container">
                  <span className='active-card'>
                    { `${LiteralsService.get('activeCard', true)}: ` }
                  </span>
                  <span className='active-card-info'>
                    { `  xxxx xxxx xxxx ${ userInfo?.paymentMethodLastFour }` }
                  </span>
                  <div className="separator"></div>
                </div>
              }
              {
                !isIframe &&
                <div className='newcard-text'>
                  { `${LiteralsService.get('newCard', true)}:` }
                </div>
              }
                <AddPaymentMethodForm
                  stripe={ stripe! }
                  elements={ elements! }
                  amount={ amount }
                  isEdit={ userInfo && userInfo.paymentMethodId && userInfo.paymentMethodLastFour ? true : false }
                  pickedService={ pickedService }
                  privacyPolicyUrl={ privacyPolicyUrl }
                  dispatch={ dispatch }
                  updateUserInfo={ updateUserInfo }
                  close={ close }
                />
            </section>
          </div>
          :
          (
            <StyledDiv>
              <span className='option-text'>
                { addOptionText }
              </span>
            <Button 
              title={ LiteralsService.get('addPaymentMethod', true) }
              onPress={ () => setShowPaymentStep(true) }
              filled
              upper
            />
            <Button 
              title={ LiteralsService.get('cancel', true) }
              onPress={ close }
              upper
            />
            </StyledDiv>
          )
        }
      </StyledDiv>
    )
  }

  if (!visible) return null
  return (
    <Modal className='small' onOverlayClick={ close }>
      { modalContent() }
    </Modal>
  )
}